module.exports = __webpack_public_path__ + "static/media/cdb27.88e15007.png";